import { useEffect, useState } from "react"

// Shared by the ToolCallGroup "Working" card and the add-in's live-review
// status bar so both render the running timer identically.
export function formatElapsed(ms: number): string {
  if (ms <= 0) return "0s"
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`
  const totalSec = Math.round(ms / 1000)
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  return `${m}m ${s}s`
}

/**
 * While `active`, re-render every 200ms so a header timer advances smoothly
 * without piling extra work onto the React tree.
 */
export function useLiveNow(active: boolean): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!active) return
    const handle = setInterval(() => setNow(Date.now()), 200)
    return () => clearInterval(handle)
  }, [active])
  return now
}
